import * as React from 'react';
export const sourceSvg = React.forwardRef(function sourceSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#F6F8FA',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M29.777 15.175c.047.378.132.755.136 1.133.012 2.723.007 5.446.006 8.17 0 .598-.272.87-.863.87H14.993c-.124 0-.248-.009-.372-.014 0-1.848.002-3.696.005-5.545l.005-.004 8.974-2.75c1.679-.515 3.354-1.043 5.033-1.558.375-.116.758-.202 1.14-.302Z',
      fill: '#D8D8D8',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M29.777 15.175c-.38.1-.762.186-1.137.301-1.679.515-3.354 1.042-5.033 1.558-2.989.92-5.98 1.836-8.974 2.75 0-1.174.038-2.35-.018-3.523-.032-.665-.125-1.358-.353-1.976-.742-2.005-2.194-3.248-4.293-3.723-.084-.02-.158-.085-.236-.13l7.738-.008.011 4.67c0 .447.272.747.669.756.365.008.62-.303.621-.756l.011-4.67c1.822 0 3.643-.02 5.465.007 1.913.028 3.407.877 4.534 2.407a5.54 5.54 0 0 1 .995 2.337Z',
      fill: '#E5E5E5',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M9.733 10.432c.078.045.152.11.236.13 2.099.475 3.55 1.716 4.29 3.723.229.62.322 1.311.354 1.976.056 1.172.017 2.349.018 3.523l-.005.004-1.282.407c0-1.39 0-2.78-.012-4.171a4.147 4.147 0 0 0-.13-.86c-.214-.932-.72-1.687-1.422-2.327a4.279 4.279 0 0 0-2.692-1.114c-1.408-.085-2.6.414-3.571 1.45-.784.835-1.204 1.817-1.213 2.954-.018 2.283-.01 4.567-.011 6.85l-1.278.407c0-2.54-.04-5.083.01-7.623.022-1.16.496-2.208 1.21-3.125.815-1.051 1.88-1.757 3.182-2.016.758-.153 1.543-.132 2.316-.188Z',
      fill: '#D4D4D4',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'm3.017 23.384 1.278-.408v1.06h9.049v-3.84l1.282-.408c0 1.85-.002 3.698-.005 5.546-3.633.003-7.266.004-10.898.005-.5 0-.712-.232-.712-.734.001-.408.004-.815.006-1.221Z',
      fill: '#BFBFBF',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M19.384 8.447h-.597l-.028.625-1.268 1.217c-.004-1.562-.01-3.119-.01-4.678 0-.32.26-.611.543-.611 1.54 0 3.08.006 4.62.01l-1.51 1.598c-.581.614-1.165 1.227-1.75 1.839Z',
      fill: '#3A74D2',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'm19.384 8.447 1.748-1.838a508.52 508.52 0 0 0 1.513-1.597c.237 0 .475-.011.712-.01.57 0 .986.419.987.992 0 .44-.009.883 0 1.321.02.839-.475 1.121-1.09 1.135-1.289.026-2.58.001-3.87-.003Zm-1.891 1.843 1.269-1.218c.007.45.015.9.021 1.352l-.01 4.67c0 .453-.257.764-.622.756-.398-.008-.67-.309-.67-.757-.005-1.557-.009-3.113-.01-4.67l.022-.134Z',
      fill: '#3066BC',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M13.344 20.196v3.84h-9.05v-1.059c0-2.283-.006-4.567.012-6.85.01-1.137.43-2.118 1.213-2.954.97-1.036 2.163-1.534 3.571-1.45 1 .045 1.953.44 2.692 1.114.703.64 1.208 1.395 1.422 2.327.073.281.116.57.128.86.015 1.392.01 2.781.012 4.172Z',
      fill: '#FEFEFE',
    }),
  );
});
sourceSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var source = {
  category: 'brand',
  colorable: false,
  name: 'source',
  svg: sourceSvg,
};
